import { cn } from "@newxsystems/shared";
import { getComponent } from "../../../../client";
import type { IRavioliCardLinkProps } from "./RavioliCardLink.props";

export const RavioliCardLink = ({ children, className, link }: IRavioliCardLinkProps) => {
  const classes = cn(
    "ravioli-motion-travel group relative block overflow-hidden border border-line bg-surface transition-[background-color,border-color,box-shadow,transform,translate]",
    link &&
      "hover:-translate-y-1 hover:border-primary hover:bg-collection hover:shadow-ravioli-action-sm focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring",
    className,
  );

  if (!link) return <article className={classes}>{children}</article>;

  const Link = getComponent("Link");
  return (
    <Link
      aria-label={link.accessibilityLabel || undefined}
      className={classes}
      href={link.href}
      rel={link.openInNewTab ? "noopener noreferrer" : undefined}
      target={link.openInNewTab ? "_blank" : undefined}
    >
      {children}
    </Link>
  );
};

RavioliCardLink.displayName = "Content::RavioliCardLink";
